
<div style="margin: 10px; padding: 2em;">
  <div class="row" *ngIf="statuslimpio" style="background-color: lightgray;">
    <div class="col">
      <p>1. Seleccione un rango de fechas</p>
      <app-rangodefechas></app-rangodefechas>
    </div>
    <div class="col">
      <p>2. Seleccione cuenca</p>
      <div class="form-group">
        <select class="form-control" id="exampleFormControlSelect1" [(ngModel)]="cuenca" (ngModelChange)="cargaLocaciones($event)">
         
          <option>VMM</option>
          <option>VMM-otros</option>
          <option>VMM - SR & TSQ</option>
          <option>Putumayo norte</option>
          <option>Putumayo sur</option>
          <option>Bogota</option>
          <option>Llanos</option>
          <option>Charapa</option>
          <option>Chanangue</option>
          <option>Iguana</option>
          <option>Perico</option>
        </select>
      </div>
    </div>
    <div class="col">
      <p>4. Haga click en el botón para generar el reporte</p>
      <button *ngIf="statuslimpio" class="btn-warning  btn-block" (click)="generarReporte()">Aceptar</button>
      
    </div>
  </div>

  <div class="row" *ngIf="! statuslimpio">
    <div class="col">
      <p><small><strong>Desde:</strong> {{servicioFechasQueryService.fechaquerymin}}</small></p>
      <p><small><strong>Hasta:</strong> {{servicioFechasQueryService.fechaquerymax}}</small></p>
    </div>
    <div class="col">
      <p><small><strong>Cuenca:</strong> {{cuenca}}</small></p>
    </div>
    <div class="col">
      <button   class="btn-warning  btn-block" (click)="customScript()">Exportar Excel</button>
      <button   class="btn-default  btn-block" (click)="nuevoReporte()">Nueva búsqueda</button>
    </div>
  </div>
  <div *ngIf="alertaActiva">
    <ngb-alert #selfClosingAlert  type="warning" >
       <div class="spinner-border" role="status">
         <span class="sr-only"></span>
       </div>
       Cargando data...
     </ngb-alert>
  </div>

    <hr>
  
  


</div>




